exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".light-login {\n\tposition: absolute;\n\tposition: static;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: #fff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/login.css
// module id = 434
// module chunks = 0